<template>
  <v-alert v-if="toast.visible" :type="toast.type" class="toast-alert" border="start" closable @click:close="hideToast">
    <div class="d-flex align-center justify-space-between">
      <span>{{ toast.message }}</span>
      <v-btn v-if="toast.copyText" icon variant="plain" size="x-small" @click.stop="copyToClipboard" class="ml-2">
        <v-icon size="small">mdi-content-copy</v-icon>
      </v-btn>
    </div>
  </v-alert>
</template>

<script setup lang="ts">
import { computed, watch } from 'vue';
import { useCortonaViewerStore } from '@/stores/cortonaViewer';

const cortonaViewerStore = useCortonaViewerStore();

const toast = computed(() => cortonaViewerStore.toast);

let timeout: ReturnType<typeof setTimeout> | null = null;

const hideToast = () => {
  cortonaViewerStore.hideToast();
};

const copyToClipboard = () => {
  if (toast.value.copyText) {
    navigator.clipboard.writeText(toast.value.copyText);
  }
};

watch(() => toast.value.visible, (newValue) => {
  if (newValue) {
    timeout = setTimeout(() => hideToast(), toast.value.timeout);
  } else if (timeout) {
    clearTimeout(timeout);
  }
});
</script>

<style scoped>
.toast-alert {
  position: fixed;
  bottom: 10px;
  right: 20px;
  width: 25%;
  z-index: 1000;
  padding: 0.6rem 1rem;
  font-size: 0.875rem;
}
</style>